












import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {譲渡譲受医療機関型} from '@/type/transfermedical/transferMedical';

@Component({})
export default class TransferMedicalSelector extends Vue {
  @Prop({default: null})
  private value!: string | null;
  @Prop({default: true})
  private nullable!: boolean;
  @Prop({default: false})
  private disabled!: boolean;

  private 譲渡譲受医療機関一覧: 譲渡譲受医療機関型[] = [];
  private 利用ユーザーである: boolean = false;

  public mounted(): void {
    this.initialize();
  }

  @Emit('input')
  private update(event: Event): string | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      return target.value as string;
    }
    return null;
  }

  @Emit('changed')
  private changed(event: Event): Event {
    return event;
  }

  private async initialize(): Promise<void> {
    this.譲渡譲受医療機関一覧 = await api.譲渡譲受医療機関一覧を取得する();
  }

  private 編集不可(): boolean {
    return this.disabled;
  }

}
